import React from "react";
import ChooseYourBra from "../components/SportsBra/chooseYourBra";
import homeStyles from "./home.module.css";
import { Link, useLocation } from "react-router-dom";
import ROUTES from "../constants/routes";
import { EXTERNALSITES } from "../constants/externalSites";
// import Container from "../components/container";

const Home = () => {
  const location = useLocation();
  const [pathname, setPathname] = React.useState(location.pathname);

  React.useEffect(() => {
    setPathname(location.pathname);
  }, [location]);

  return (
    <div className={homeStyles.container}>
      <div className={homeStyles.content}>
        <div className={homeStyles.textContainer}>
          <div className={homeStyles.textContentContainer}>
            <h1 className={homeStyles.tagLine}>
              <span>A sports bra is essential sporting equipment </span>
              <span>for female athletes and active women</span>
            </h1>
          </div>
          <div className={homeStyles.logoContainer}>
            <a
              href={EXTERNALSITES.AIS}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className={homeStyles.image}
                src={require(`../assets/AIS_Gold_Stacked.png`).default}
                alt="AIS Logo"
              />
            </a>
            <a
              href={EXTERNALSITES.UOW}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className={homeStyles.image}
                src={require(`../assets/uowLogo.png`).default}
                alt="UOW Logo"
              />
            </a>
          </div>
        </div>
        <div className={homeStyles.form}>
          <ChooseYourBra
            wizardHeading={
              "Enter your bra size, age, and the level of breast movement during physical activity to get personalised recommendations on the sports bra styles best suited to your body and support needs."
            }
          >
            {pathname !== "/education" && (
              <Link to={{ pathname: ROUTES.EDUCATION }}>
                <a href="/">
                  Learn more about the different sports bra designs
                </a>
              </Link>
            )}
          </ChooseYourBra>
        </div>
      </div>
    </div>
  );
};

export default Home;
